import { render, staticRenderFns } from "./package.vue?vue&type=template&id=76b60330&"
import script from "./package.vue?vue&type=script&lang=js&"
export * from "./package.vue?vue&type=script&lang=js&"
import style0 from "./package.vue?vue&type=style&index=0&lang=css&"
import style1 from "./package.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports